import { extension } from 'mime-types'
import { isImageMimeType } from 'util/mime'

import { styles, extentionStyles } from './styles'

const extentionStylesMap = {
  pdf: extentionStyles.pdf,
  doc: extentionStyles.doc,
  docx: extentionStyles.doc,
  xls: extentionStyles.xls,
  xlsx: extentionStyles.xls,
}

export default function FileIcon({
  fileType,
  fileName,
  url,
  onClick,
  disabled = false,
}) {
  const fileExtension = extension(fileType)
  const isImage = isImageMimeType(fileType)

  if (/png|jpg|jpeg/.test(fileExtension)) {
    return <img src={url} alt={fileName} css={styles.image} onClick={onClick} />
  }

  const content = (
    <div css={isImage ? styles.imageWrapper : null} onClick={onClick}>
      <div css={styles.placeholder} />
      <div css={[styles.extension, extentionStylesMap[fileExtension]]}>
        {fileExtension}
      </div>
    </div>
  )

  if (/pdf/.test(fileExtension)) {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        disabled={disabled}
      >
        {content}
      </a>
    )
  }

  return content
}
